import { render } from "./WorkerTagEditor.vue?vue&type=template&id=3bc4ff33"
import script from "./WorkerTagEditor.vue?vue&type=script&lang=js"
export * from "./WorkerTagEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__